import moment from "moment";
import { formatMoney } from "../../features/utils/formatMoney";

export function templateTransactionData(data, wallet) {
  let amountElements = [
    {
      type: "title",
      value: "Amount",
    },
    {
      type: "text",
      value: (data?.isCredit ? "" : "- ") + formatMoney(data?.amount),
      className: data?.isCredit ? "text-green-600" : "text-red-600",
    },
  ];
  let walletBalance = {
    elements: [
      {
        type: "title",
        value: "Current balance",
      },
      {
        type: "text",
        value: data?.remainingWalletBalance
          ? formatMoney(data?.remainingWalletBalance)
          : "----",
      },
    ],
    value: "",
    width: "md:w-[15%]",
  };

  return [
    {
      elements: [
        {
          type: "title",
          value: "Date",
        },
        {
          type: "text",
          value: moment(data?.createdAt).format("DD MMMM YYYY"),
        },
        {
          type: "text",
          value: moment(data?.createdAt).format("h:mmA"),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Reason",
        },
        {
          type: "text",
          value: data?.reason,
        },
      ],
      value: "",
      width: "md:w-[15%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Description",
        },
        {
          type: "text",
          value: data?.description,
        },
      ],
      value: "",
      width: "md:w-[25%]",
    },
    {
      elements: [
        {
          type: "title",
          value: "Payment Mode",
        },
        {
          type: "text",
          value: data?.paymentMode,
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: amountElements,
      value: "",
      width: "md:w-[15%]",
    },
    wallet ? walletBalance : undefined,
    {
      elements: [
        { type: "title", value: "Status" },
        { type: "status", value: data?.status },
      ],
      width: "md:w-[10%]",
    },
  ].filter((item) => item);
}
